import $ from 'jquery';

import ChairishState from 'chairisher/util/state';

const FILTER_FORM_SELECTOR = '#js-portfolio-filter';

class PortfolioFiltersView {
    constructor() {
        this.state = new ChairishState({
            filterAndSortNames: ['room', 'style', 'page'],
        });
    }

    handleSubmit(inputFacet) {
        const $inputFacet = $(inputFacet);
        const stateVal = $inputFacet.val();
        const stateName = $inputFacet.attr('name');
        const isChecked = $inputFacet.is(':checked');

        // with any state change we need to remove page since it's a new set of results that starts on page 1
        this.state.removeState('page', undefined, false);

        if (isChecked) {
            this.pushState(stateName, stateVal);
        } else {
            this.state.removeState(stateName, stateVal);
        }

        this.state.pushState();

        this.submit();
    }

    /**
     * Appends a new state to the state object, and pushes the state to the browser history.
     * If you don't want to change the browser history, pass in `false` as the 3rd argument.
     *
     * @param {string} fieldName The name of the facet input being added to the state object
     * @param {string} fieldValue The value of the facet input being added to the state object
     */
    pushState(fieldName, fieldValue) {
        let currentVal = this.state.getStateVal(fieldName);

        if (currentVal) {
            if (Array.isArray(currentVal)) {
                currentVal.push(fieldValue);
            } else {
                currentVal = [currentVal, fieldValue];
            }
        } else {
            currentVal = fieldValue;
        }

        this.state.setStateVal(fieldName, currentVal);

        this.state.pushState();
    }

    /**
     * @returns {$.Deferred}
     */
    submit() {
        return $.ajax({
            dataType: 'json',
            url: this.state.getStateUrl(),
        }).done((data) => {
            $('.js-paginator-wrapper').html(data.data.pager_truncated_html.trim());
            $('.js-business-image-grid-wrapper').html(data.data.business_images_html);
        });
    }

    /**
     * Binds actions that are related to filters form
     */
    bindFacets() {
        const $filtersForm = $(FILTER_FORM_SELECTOR);

        $filtersForm.on('change', 'input', (e) => {
            this.handleSubmit(e.currentTarget);
        });
    }
}

export default PortfolioFiltersView;
